var delayTimer;
export default function Search(props) {
  const { inputClasses, iconClasses, placeholder, wrapperClasses, onChangeHook } = props

  const handleSearch = (query) => {
    clearTimeout(delayTimer);
    delayTimer = setTimeout(() => onChangeHook(query), 500)
  }

  return (
    <div className={`input-group ${wrapperClasses}`}>
      <input onChange={(search) => handleSearch(search.target.value)} type="text" className={`form-control ${inputClasses}`} placeholder={placeholder} />
      <div className="input-group-append">
        <span className={`input-group-text search-button position-static bg-light ${iconClasses}`}><i className="la la-search text-muted" /></span>
      </div>
    </div>
  )
}